import { Theme, ThemeOptions } from '@mui/material/styles';

/**
 * Helper function to get FileUploader styles
 * Used directly in the component with useTheme hook
 */
export const getFileUploaderStyles = (theme: Theme) => ({
  container: {
    width: '100%',
    padding: '12px 20px 28px 20px',
    gap: 2,
  },

  header: {
    display: 'flex',
    flexDirection: 'column',
    mb: 8,
  },

  closeButtonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    height: '20px',
  },

  closeButton: {
    padding: 0,
    width: '20px',
    height: '20px',
    color: theme.palette.M3?.sys?.light?.['on-surface-variant'],
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },

  closeIcon: {
    height: '24px !important',
    width: '24px !important',
  },

  titleText: {
    ...theme.typography.M3?.headline?.small,
    color: theme.palette.M3?.sys?.light?.['on-surface'],
  },

  dropzone: {
    border: `1px dashed ${theme.palette.M3?.sys?.light?.outline}`,
    borderRadius: '8px',
    backgroundColor: theme.palette.M3?.sys?.light?.surface,
    padding: '24px 40px',
    textAlign: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: theme.palette.M3?.sys?.light?.background,
    },
  },

  dropzoneDisabled: {
    cursor: 'not-allowed',
    opacity: 0.6,
    '&:hover': {
      backgroundColor: undefined,
    },
  },

  uploadIcon: {
    fontSize: 24,
    color: theme.palette.M3?.sys?.light?.['on-surface-variant'],
  },

  instructionText: {
    ...theme.typography.M3?.body?.medium,
    color: theme.palette.M3?.sys?.light?.['on-surface-variant'],
  },

  clickText: {
    color: theme.palette.M3?.sys?.light?.['on-primary-fixed'],
  },

  supportedFormatsLabel: {
    fontWeight: 700,
  },

  supportedFormatsText: {
    ...theme.typography.M3?.body?.medium,
    color: theme.palette.M3?.sys?.light?.['on-surface-variant'],
  },

  fileInput: {
    display: 'none',
  },

  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    pt: 4,
  },
});

/**
 * Default export for theme extension system
 * Required by extendMuiTheme to auto-merge component themes
 */
const getFileUploaderTheme = (_theme: Theme): ThemeOptions => {
  return {
    components: {},
  };
};

export default getFileUploaderTheme;
